import { GarbageCollector } from '../utils';

/**
 *
 */
export const withEvents = (ComponentClass, listeners) => {
  const gc = new GarbageCollector();

  class Enchanced extends ComponentClass {
    connectedCallback() {
      super.connectedCallback();

      this.__add__events__handler();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      gc.release();
    }

    __add__events__handler() {
      if (super.__add__events__handler) super.__add__events__handler();

      gc.addMany(
        listeners.map(({ event, handler, params = {} }) => {
          /**
           * @param {CustomEvent<any>} e
           */
          const callback = e => handler(e, this);
          const { element = 'document' } = params;
          // prettier-ignore
          const elements = {
            self: this,
            'document': document,
            'window': window,
          };

          elements[element].addEventListener(event, callback, params);

          return () => elements[element].removeEventListener(event, callback, params);
        })
      );
    }
  }

  return Enchanced;
};
